<template>
  <authentic-modal ref="subscriptionModal" id="subscription-modal" size="xl" :hideFooter="true" title="">
    <div class="conntainer select-payment">
      <div class="card border-0">
        <p class="card-text subscription-title mb-0 px-3 text-center text-sm-start">{{ t("subscription.welcome_title") }}</p>
        <p class="card-text subscription-subtitle px-4 px-sm-3 py-2 py-sm-0 text-center text-sm-start">{{ t("subscription.choose_plan") }}</p>
      </div>
      <div class="row choose">
        <RealPlanGroup />
      </div>
      <div class="row">
        <div class="col">
          <p class="card-text text-muted ps-4 footnotes">* {{ t("subscription.additional_experiences_note") }}
          </p>
          <p class="card-text text-muted ps-4 footnotes">{{ t("subscription.custom_integration_note") }}</p>
        </div>
      </div>
    </div>
  </authentic-modal>
</template>

<script setup lang="ts">
  import { ref, inject, onBeforeMount, onBeforeUnmount } from "vue";
  import AuthenticModal from "./AuthenticModal.vue";
  import RealPlanGroup from "./RealPlanGroup.vue";
  import { useI18n } from "vue-i18n";

  const subscriptionModal = ref<typeof AuthenticModal | null>(null);
  const emitter: any = inject("emitter");
  const { t } = useI18n();

  const modalTitle = "Select a plan";

  onBeforeMount(() => {
    emitter.on("subscription-modal", () => {
      subscriptionModal.value!.showModal();
    });
    emitter.on("subscription-modal-close", () => {
      subscriptionModal.value!.hideModal();
    });
  });

  onBeforeUnmount(() => {
    emitter.off("subscription-modal");
    emitter.off("subscription-modal-close");
  });
</script>

<style scoped>
.subscription-title {
  font-family: "proximanova-medium", sans-serif;
  font-size: 32px;
}

.subscription-subtitle {
  font-size: 16px;
  margin-bottom: -20px !important;
}

.footnotes {
  margin-bottom: 5px;
  font-size: 12px;
}

.choose {
  margin-bottom: -20px !important;
}

.select-payment {
  height: 74vh !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
</style>
